import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { InsuranceTypesService } from '@core';
import { ProductsService } from 'app/products/products.service';
import { map, take } from 'rxjs';

export const validProductGuard: CanActivateFn = (route) => {
    const router = inject(Router);

    const slug = route.paramMap.get('productSlugOrId');
    if (!slug) {
        redirectProductPage(router);
        return false;
    }
    const product = inject(ProductsService).getBySlug(slug);

    if (product === null) {
        redirectProductPage(router);
        console.error(new Error('product does not exist'));
        return false;
    }

    if (product.legacy) {
        redirectProductPage(router);
        console.error(new Error('product is legacy product'));
        return false;
    }

    return inject(InsuranceTypesService)
        .get(product.insuranceTypeId)
        .pipe(
            map((insuranceType) => {
                if (insuranceType === null) {
                    redirectProductPage(router);
                    console.error(new Error('No insurance type found for the current product'));
                    return false;
                }
                return true;
            }, take(1)),
        );
};

const redirectProductPage = (router: Router): void => {
    router.navigate(['/', 'produkte']);
};
